<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © StampThePassport
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Developed by <a href="https://elkanio.com/" target="_blank" class="text-reset">Elkanio</a>
                </div>
            </div>
        </div>
    </div>
</footer>